import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import {
  ReactPlugin,
  withAITracking
} from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { ComponentType } from 'react'
const browserHistory = createBrowserHistory()
const reactPlugin = new ReactPlugin()

const ai = new ApplicationInsights({
  config: {
    instrumentationKey:
      process.env.REACT_APP_APPINSIGHTS_KEY ||
      'xxxxxxxxxxx-xxxxxxxxxx-xxxxxxx-xxxxx',
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    enableRequestHeaderTracking: true,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    }
  }
})

function telemetryInitializer(envelope: any) {
  envelope.data['vale-user-id'] = localStorage.getItem('user-id')
  envelope.data['vale-session-id'] = ai.context.getSessionId()
}

ai.addTelemetryInitializer(telemetryInitializer)
ai.loadAppInsights()

export default (Component: ComponentType<unknown>) =>
  withAITracking(reactPlugin, Component)
export const appInsights = ai.appInsights
export { ai }
export { reactPlugin }
